import * as React from 'react';
import { FormLabel as MuiFormLabel } from '@material-ui/core';

var FormLabel = function FormLabel(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      error = _ref.error,
      label = _ref.label,
      required = _ref.required;
  return /*#__PURE__*/React.createElement(MuiFormLabel, {
    disabled: disabled,
    error: error,
    required: required
  }, children, label);
};

export default FormLabel;

try {
  FormLabel.__docgenInfo = {
    description: '',
    displayName: 'FormLabel',
    methods: [],
    props: {
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: false,
        type: {
          name: 'string'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'If `true`, the label should be displayed in a disabled state.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      error: {
        defaultValue: null,
        description: 'If `true`, the label should be displayed in an error state.',
        name: 'error',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the label will indicate that the input is required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map